var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "swiper" },
    [
      _c(
        "div",
        {
          ref: "wrapper",
          staticClass: "swiper-wrapper",
          class: { animation: _vm.animation }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "touch",
                  rawName: "v-touch:start",
                  value: _vm.handlerStart,
                  expression: "handlerStart",
                  arg: "start"
                },
                {
                  name: "touch",
                  rawName: "v-touch:end",
                  value: _vm.handlerEnd,
                  expression: "handlerEnd",
                  arg: "end"
                }
              ],
              ref: "slides",
              staticClass: "swiper-slides",
              on: { mouseover: _vm.handlerStart, mouseleave: _vm.handlerEnd }
            },
            _vm._l(_vm.items, function(item, i) {
              return _c(
                "div",
                { key: i, staticClass: "swiper-slide", style: _vm.itemStyle },
                [
                  _vm._t("default", null, {
                    item: item,
                    isActive: i === _vm.currentSlide,
                    index: i
                  })
                ],
                2
              )
            }),
            0
          )
        ]
      ),
      _vm.items.length > _vm.slidesToShowComputed
        ? [
            _c("vue-client-only", [
              _c("div", [
                _vm.arrows && _vm.adaptive.isDesktop
                  ? _c(
                      "div",
                      { staticClass: "arrows" },
                      _vm._l(["left", "right"], function(direction) {
                        return _c(
                          "div",
                          {
                            key: direction,
                            class: ["arrow-" + direction],
                            on: {
                              click: function($event) {
                                direction == "left"
                                  ? _vm.prevSlide()
                                  : _vm.nextSlide()
                              }
                            }
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "24",
                                  height: "24",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "#999999",
                                    d:
                                      "M23 10.45L3.41357 10.45L10.1442 3.70742C10.5347 3.31691 10.5347 2.68339 10.1442 2.29288C9.7542 1.90237 9.12019 1.90237 8.73018 2.29288L0.293004 10.7301C0.246503 10.7766 0.204499 10.8281 0.167498 10.8836C0.151498 10.9076 0.140497 10.9341 0.126497 10.9596C0.108996 10.9911 0.0900047 11.0221 0.0760044 11.0556C0.0625041 11.0881 0.0544945 11.1226 0.0444943 11.1566C0.0359941 11.1851 0.025 11.2121 0.0194999 11.2421C-0.00650066 11.3711 -0.00650066 11.5046 0.0194999 11.6336C0.025 11.6636 0.0359941 11.6906 0.0444943 11.7196C0.0544945 11.7531 0.0625041 11.7876 0.0760043 11.8201C0.0900046 11.8541 0.108996 11.8846 0.126497 11.9161C0.140497 11.9416 0.151498 11.9681 0.167498 11.9921C0.204499 12.0476 0.246503 12.0991 0.293004 12.1456L8.73018 20.5828C8.92518 20.7778 9.18119 20.8758 9.43719 20.8758C9.6932 20.8758 9.9492 20.7778 10.1442 20.5828C10.5347 20.1918 10.5347 19.5592 10.1442 19.1682L3.41357 12.45L23 12.45C23.5525 12.45 24 11.9901 24 11.4381C24 10.8856 23.5525 10.45 23 10.45Z"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.dots
                  ? _c(
                      "div",
                      { class: ["dots", { "dots-disabled": _vm.isIOS }] },
                      _vm._l(_vm.dynamicDots, function(dot, i) {
                        return _c("div", {
                          key: i,
                          style: dot.style,
                          on: {
                            click: function($event) {
                              return _vm.goToSlide(i)
                            }
                          }
                        })
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }